import { API_BASE_URL } from '@/config/api';

/**
 * Resolve property image URLs for display.
 * Supports external URLs and MongoDB-backed /api/media/{id} paths.
 */
export function resolveMediaUrl(url) {
  if (!url) return '';
  if (url.startsWith('http://') || url.startsWith('https://') || url.startsWith('data:')) {
    return url;
  }
  if (url.startsWith('/api/')) {
    return `${API_BASE_URL}${url}`;
  }
  if (url.startsWith('api/')) {
    return `${API_BASE_URL}/${url}`;
  }
  return url;
}

/**
 * Returns true if the URL points to a MongoDB-backed media asset.
 */
export function isMongoMediaUrl(url) {
  return typeof url === 'string' && url.includes('/api/media/');
}

export function extractMediaId(url) {
  if (!url) return null;
  const marker = '/api/media/';
  const index = url.indexOf(marker);
  if (index === -1) return null;
  return url.slice(index + marker.length).split('?')[0];
}
